import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, InfoRow } from './styled';
import { Apartment } from '../../../../graphql/types';
import { prettyNumber } from '../../../../utils/helpers';

interface ResidenceApartmentsInfoProps {
  apartments?: Apartment[];
  priceMin?: number;
  currency?: string;
  deadline?: string;
  hasBillOfSale: boolean;
}

export const ResidenceApartmentsInfo: React.FC<
  ResidenceApartmentsInfoProps
> = ({ apartments = [], priceMin, currency, deadline, hasBillOfSale }) => {
  const { t } = useTranslation();
  const minArea =
    apartments?.length > 0 && Math.min(...apartments?.map(item => item?.area));
  const maxArea =
    apartments?.length > 0 && Math.max(...apartments?.map(item => item?.area));

  return (
    <Container>
      {minArea && maxArea && (
        <InfoRow tag="title_4_new">
          <span>{t('quick_links.flats')}</span>
          <span>
            {t('pages.current_item.apartments_area', {
              from: minArea,
              to: maxArea
            })}
          </span>
        </InfoRow>
      )}
      {priceMin && (
        <InfoRow tag="title_4_new">
          <span>{t('residences.price')}</span>
          <span>
            {t('residences.priceMin', {
              priceMin: prettyNumber(priceMin),
              currency
            })}
          </span>
        </InfoRow>
      )}
      {deadline && (
        <InfoRow tag="title_4_new">
          <span>{t('residences.deadline')}</span>
          <span>{deadline}</span>
        </InfoRow>
      )}
      {hasBillOfSale && (
        <InfoRow tag="title_4_new">
          <span>{t('residences.billOfSale')}</span>
          <span>{t('residences.hasBillOfSale')}</span>
        </InfoRow>
      )}
    </Container>
  );
};
